var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandPaperBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Icon_awesome-hand-paper",
    d: "M29.9,9.8c-1.5,0-2.8,1.2-2.8,2.8c0,0,0,0,0,0v6h-0.5v-12c0-1.5-1.2-2.8-2.8-2.8 c0,0,0,0,0,0c-1.5,0-2.7,1.2-2.7,2.7v12.1h-0.5V3.8c0-1.5-1.2-2.8-2.8-2.8c0,0,0,0,0,0c-1.5,0-2.7,1.2-2.7,2.7v14.8h-0.5v-12 c0-1.5-1.2-2.8-2.8-2.8c0,0,0,0,0,0c-1.5,0-2.7,1.2-2.7,2.7v16.1l-2.2-3c-0.9-1.2-2.6-1.5-3.8-0.7s-1.5,2.6-0.7,3.8 c0,0,0,0.1,0.1,0.1l8.6,11.8c0.6,0.8,1.6,1.4,2.7,1.4h13.5c1.5,0,2.8-1,3.2-2.5l1.8-7.7c0.2-1,0.3-2,0.3-3V12.5 C32.6,11,31.4,9.8,29.9,9.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPaperBlu);
export default __webpack_public_path__ + "static/media/hand-paper-blu.9546ee36.svg";
export { ForwardRef as ReactComponent };